import { css, Global } from "@emotion/react";
import { useEffect } from "react";
import useIsMobile from "../../hooks/device/useIsMobile";

function showChatbot(visible: boolean): boolean {
  const target = document.getElementById("conversations-wrap");
  if (target) target.style.display = visible ? "initial" : "none";
  return !!target;
}

export function ActiveCampaignChatHandler({ condition }: Readonly<{ condition?: () => boolean }>) {
  const isMobile = useIsMobile();

  useEffect(() => {
    if (typeof condition === "function" && !condition()) {
      return () => {};
    }

    showChatbot(true);

    const retries = 2;
    let counter = 0;

    // is not present an event to trigger chat readyness
    const interval = setInterval(() => {
      if (showChatbot(true)) {
        clearInterval(interval);
      }

      counter++;
      if (counter >= retries) {
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
      showChatbot(false);
    };
  }, [condition]);

  if (!isMobile) return <></>;

  return (
    <Global
      styles={css`
        #conversations-wrap {
          bottom: 64px !important;
        }
      `}
    />
  );
}
